import type { RouteLocationNormalized } from 'vue-router'
import isArray from 'lodash/isArray'

const isSlug = async (route: RouteLocationNormalized) => {
  if (!('slug' in route.params)) {
    return false
  }

  const slugs = route.params.slug

  return isArray(slugs) && slugs.filter(value => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)).length > 0
}

export default isSlug
